import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../..";
import { setHome } from "./reducer";

import Home from "../../utils/apiServices/home";
import notify from "../../utils/notify";

function useUpdateHome() {
  const dispatch = useDispatch();

  const detailedRestaurants = useSelector(
    (state: IRootState) => state.home.value.detailedRestaurant
  );
  function updateHome(data: { lat: string; lng: string }) {
    dispatch(setHome({ homeLoading: true }));

    Home.getHome({
      lat: data.lat,
      lng: data.lng,
    })
      .then((res) => {
        if (res.success) {
          const { data } = res;
          dispatch(
            setHome({
              home: {
                banners: data.banners,
                categories: data.categories,
                itemCampaigns: data.itemCampaigns,
                most_reviewed: data.most_reviewed.map((data: any) => ({
                  ...data,
                  isFavourite: data.wishlist !== null,
                })),
                popular: {
                  total_size: data.popular.total_size,
                  limit: data.popular.number,
                  offset: data.popular.number,
                  restaurants: data.popular.restaurants.map((data: any) => ({
                    ...data,
                    isFavourite: data.wishlist !== null,
                  })),
                },
              },
              homeLoading: false,
            })
          );
        } else {
          dispatch(setHome({ homeLoading: false }));
        }
      })
      .catch(() => {
        dispatch(setHome({ homeLoading: false }));
        
      });
  }
  function updateDetailedRestaurant(slug: string) {
    dispatch(setHome({ detailedRestaurantLoading: true }));

    const singleRestaurant = detailedRestaurants.find(
      (restaurant) => restaurant.slug === slug
    );

    if (singleRestaurant) {
      dispatch(setHome({ detailedRestaurantLoading: false }));
    } else {
      const new_slug = slug.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      Home.getEstablishment(new_slug)
        .then((res) => {
          if (res.success) {
            dispatch(
              setHome({
                detailedRestaurant: [
                  ...detailedRestaurants,
                  {
                    ...res.data,
                    item: res.data.item.map((item: any) => ({
                      ...item,
                      isFavourite: item.wishlist !== null,
                    })),
                  },
                ],
                detailedRestaurantLoading: false,
              })
            );
          } else {
            notify("error", res.message);
            dispatch(setHome({ detailedRestaurantLoading: false }));
          }
        })
        .catch(() => {
          
          dispatch(setHome({ detailedRestaurantLoading: false }));
        });
    }
  }

  function updateEstablishment(type: string) {
    setHome({
      restaurantLoading: true,
    });
    Home.getEstablishmentByType(type)
      .then((res) => {
        if (res.success) {
          dispatch(
            setHome({
              restaurant: res.data.map((data: any) => ({
                ...data,
                isFavourite: data.wishlist !== null,
              })),
              restaurantLoading: false,
            })
          );
        } else {
          notify("error", res.message);
          dispatch(setHome({ restaurantLoading: false }));
        }
      })
      .catch(() => {
        
        dispatch(setHome({ restaurantLoading: false }));
      });
  }

  function updateStore(type: string) {
    setHome({
      storeLoading: true,
    });
    Home.getEstablishmentByType(type)
      .then((res) => {
        if (res.success) {
          dispatch(
            setHome({
              store: res.data.map((data: any) => ({
                ...data,
                isFavourite: data.wishlist !== null,
              })),
              storeLoading: false,
            })
          );
        } else {
          notify("error", res.message);
          dispatch(setHome({ storeLoading: false }));
        }
      })
      .catch(() => {
        
        dispatch(setHome({ storeLoading: false }));
      });
  }

  function updateSupermarket(type: string) {
    setHome({
      supermarketLoading: true,
    });
    Home.getEstablishmentByType(type)
      .then((res) => {
        if (res.success) {
          dispatch(
            setHome({
              supermarket: res.data.map((data: any) => ({
                ...data,
                isFavourite: data.wishlist !== null,
              })),
              supermarketLoading: false,
            })
          );
        } else {
          notify("error", res.message);
          dispatch(setHome({ supermarketLoading: false }));
        }
      })
      .catch(() => {
        
        dispatch(setHome({ supermarketLoading: false }));
      });
  }
  return {
    updateHome,
    updateDetailedRestaurant,
    updateEstablishment,
    updateStore,
    updateSupermarket,
  };
}

export default useUpdateHome;
